/**
 * Tipos de variantes do alert
 *
 * @category Components
 */
export type AlertVariant = 'success' | 'error';

export const ALERT_ICONS: Record<AlertVariant, string> = {
  success: 'confirmacao',
  error: 'error_circle_base',
};
